import * as yup from 'yup';
import { ProjectTypeEnum } from '~/api/types';

export const projectNameRules = {
  max: 128,
  pattern: /^[A-Za-z0-9\s_.:/=+\-@{}\[\]()&^%$#!~`|\\'"?,;<>]*$/,
} as const;

export const MAX_DESCRIPTION_LENGTH = 256;

export const projectSchema: yup.AnyObjectSchema = yup
  .object({
    name: yup
      .string()
      .transform((v) => (typeof v === 'string' ? v.trim() : v))
      .max(
        projectNameRules.max,
        `Project name should contain at least 1 characters and up to ${projectNameRules.max} characters`,
      )
      .matches(
        projectNameRules.pattern,
        'Only spaces, alphanumeric and the following special characters are allowed: _.:/=+-@{}[]()&^%$#!~`|\\"\'?,;<>',
      )
      .required('Project name is a required field'),
    type: yup
      .mixed<ProjectTypeEnum>()
      .oneOf(Object.values(ProjectTypeEnum))
      .required('Project type is a required field'),
    description: yup
      .string()
      .max(MAX_DESCRIPTION_LENGTH, `Description should contain up to ${MAX_DESCRIPTION_LENGTH} characters`)
      .transform((v) => (typeof v === 'string' ? v.trim() : v))
      .required('Description is a required field'),
    operating_unit_id: yup
      .number()
      .typeError('Operating unit id is a required field')
      .required('Operating unit id is a required field'),
    cost_center_id: yup.mixed().nullable().notRequired(),
    wbs_code_id: yup
      .mixed()
      .nullable()
      .when('cost_center_id', {
        is: (v: unknown) => !v,
        then: (schema) => schema.required('WBS or cost center code is required'),
        otherwise: (schema) => schema.notRequired(),
      }),
    dataset_ids: yup.array().of(yup.number().required()).nullable().notRequired(),
    destination_dataset_ids: yup
      .array()
      .of(yup.number().required())
      .when('type', {
        is: ProjectTypeEnum.PRODUCER,
        then: (schema) =>
          schema.min(1, 'Destination dataset is a required field').required('Destination dataset is a required field'),
        otherwise: (schema) => schema.notRequired().nullable(),
      }),
  })
  .required();
